import { render } from "./BasicLayout.vue?vue&type=template&id=452809d1&scoped=true&ts=true"
import script from "./BasicLayout.vue?vue&type=script&lang=ts"
export * from "./BasicLayout.vue?vue&type=script&lang=ts"

import "./BasicLayout.vue?vue&type=style&index=0&id=452809d1&lang=less&scoped=true"

import exportComponent from "/root/workspace/pt-manage-plugin-admin/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-452809d1"]])

export default __exports__